import React, { useState, useEffect } from 'react';
import { Link, Redirect } from 'react-router-dom';
import Functions from '../../api/Functions';
import { compose } from 'redux';
import { connect } from 'react-redux';
import './ContestsMenu.css';
import LinkCard from '../../components/general/LinkCard';

function ContestsMenu(props) {
  const [showResults, setShowResults] = useState(false);
  const [showWinners, setShowWinners] = useState(false);
  const [winners, setWinners] = useState([]);
  const [showError, setShowError] = useState(false);
  const [results, setResults] = useState({});
  //TODO: remove next 2 lines after super admin implementation
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);
  useEffect(() => setIsSuperAdmin(false), [])

  const { auth } = props;
  if (!auth.uid) return <Redirect to="/signin" />;

  const cleanResults = () => {
    setShowWinners(false);
    setWinners([])
    setShowError(false);
    setShowError(false);
    setResults({});
  };

  const createCollectorEntries = () => {
    cleanResults();
    Functions.manualCreatePynCollectorEntries()
      .then((results) => {
        setResults(results.data);
        setShowResults(true);
        setShowError(false);
      })
      .catch((e) => {
        console.log(e.message);
        setResults({});
        setShowError(true);
      });
  };

  const getWinnerContest = () => {
    cleanResults();
    Functions.manualGetWinnerContest()
      .then((results) => {
        setShowWinners(true);
        setWinners(results.data)
      })
      .catch((e) => {
        console.log(e.message);
        setWinners([]);
        setShowError(true);
      });
  };

  const renderWinners = () => {
    return (
      <div>
        {showWinners && winners ? (
          <div>
            <h4>Winners</h4>
            {winners.map((winner, index) => {
              return (
                <div key={index}>
                  <h6>Profile Id: {winner}</h6>
                </div>
              );
            })}
          </div>
        ) : <div />}
      </div>);
  };

  //TODO: render after super admin implementation
  const testDataMenu = () => {
    return (
      <div className="col l3 m6 s12">
        <div className="card horizontal">
          <div className="card-stacked">
            <div className="card-content">
              <p>Create Test Data Contest by ID users</p>
            </div>
            <div className="card-action">
              <Link to="contestTestData">Create Test Data</Link>
            </div>
          </div>
        </div>
      </div>
    )
  }

  //TODO: render after super admin implementation
  const manualPynsCollectorEntries = () => {
    return (
      <div className="col l3 m6 s12">
        <div className="card horizontal">
          <div className="card-stacked">
            <div className="card-content">
              <p>By Pyn Collected</p>
            </div>
            <div className="card-action">
              <a href="#!" onClick={() => createCollectorEntries()}>
                Generate entries
              </a>
            </div>
          </div>
        </div>
      </div>
    )
  }

  const winnerContest = () => {
    return (
      <div className="col l3 m6 s12">
        <div className="card horizontal">
          <div className="card-stacked">
            <div className="card-content">
              <p>Contest Winners</p>
            </div>
            <div className="card-action">
              <Link to="winnersContest">Contest Winners</Link>
            </div>
          </div>
        </div>
      </div>
    )
  }

  const startContestManually = () => {
    return (
      <div className="col l3 m6 s12">
        <div className="card horizontal">
          <div className="card-stacked">
            <div className="card-content">
              <p>Start contest manually</p>
            </div>
            <div className="card-action">
              <a href="#!" onClick={() => getWinnerContest()}>
                Start contest manually
              </a>
            </div>
          </div>
        </div>
      </div>
    )
  }

  const downloadEntries = () => {
    return (
      <div className="col l3 m6 s12">
        <div className="card horizontal">
          <div className="card-stacked">
            <div className="card-content">
              <p>Download Contest Entries</p>
            </div>
            <div className="card-action">
              <Link to="downloadEntries">Download Entries</Link>
            </div>
          </div>
        </div>
      </div>
    )
  }

  const runContests = () => {
    return (
      <div className="col l3 m6 s12">
        <div className="card horizontal">
          <div className="card-stacked">
            <div className="card-content">
              <p>Run contest</p>
            </div>
            <div className="card-action">
              <Link to="runContests">
                Run contest
              </Link>
            </div>
          </div>
        </div>
      </div>
    )
  }

  const sectionManageEntries = () => {
    return (
      <div>
        <div className="subtitle-section">Manage entries</div>
        <div className="row">
          <LinkCard title="Invalidate entries" actionText="Go to invalidate" link="/invalidateEntries" />
        </div>
      </div>
    );
  };

  return (
    <div className="container">
      <div className="title-section">Contests Entries</div>
      {showError ? <h6 className="red-text">Service temporarily unavailable</h6> : <div />}
      <div className="subtitle-section">Manual Contest Entries by Actions</div>
      <div className="row">

        <LinkCard title={'By Trivia Completed'} actionText={'Create Entries'} link={'triviaEntries'} />
        <LinkCard title={'By Mission Completed'} actionText={'Create Entries'} link={'missionEntries'} />
        <LinkCard title={'By Pyn Collected'} actionText={'Create Entries'} link={'pynCollectorEntries'} />
        <LinkCard title={'By Pyn Collected Filtered'} actionText={'Create Entries'} link={'pynCollectorFilteredEntries'} />
      </div>

      <div className="subtitle-section">Contest Results</div>
      <div className="row">
        {downloadEntries()}
        {runContests()}
        {winnerContest()}
        {startContestManually()}
        {isSuperAdmin && testDataMenu()}
        {isSuperAdmin && manualPynsCollectorEntries()}
      </div>
      {sectionManageEntries()}

      {showResults && results && results.entries ? (
        <div className="resultsContainer">
          <h5>Results</h5>
          {results.entries.map((entry, index) => {
            return (
              <div key={index}>
                <h6>Entry Id: {entry}</h6>
              </div>
            );
          })}
        </div>
      ) : (
        <div />
      )}
      {renderWinners()}
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    auth: state.firebase.auth,
  };
};

export default compose(connect(mapStateToProps))(ContestsMenu);
